<template>
  <div>
    <!-- 线索流转 分配-->
    <el-dialog :title="'线索'+type" :visible.sync="showUpgrateForm" width="600px" :close-on-click-modal="false" center>
      <el-form label-width="120px" :model="upgradeForm" ref="upgradeForm" :rules="rules_Upgrade">

        <el-form-item :label="type+'到'" prop="userId">
          <el-select style="width:100%" :disabled="type=='领取'" v-model="upgradeForm.userId" prop="userId" clearable placeholder="请选择"
                     filterable>
            <el-option v-for="(item,index) in sysUserList" :key="index" :label="item.userName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="意向城市" prop="cityId">
          <el-select v-model="upgradeForm.cityId" clearable placeholder="请选择城市" filterable>
            <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向驿站" prop="postStationId">
          <el-select v-model="upgradeForm.postStationId" clearable placeholder="请选择驿站" filterable>
            <template v-for="(item,index) in postStationList">
              <el-option :key="index" v-if="item.cityId==upgradeForm.cityId" :label="item.postStationName"
                         :value="item.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="意向服务站" prop="postStationId">
          <el-select v-model="upgradeForm.stationId" clearable placeholder="请选择服务站" filterable>
            <template v-for="(item,index) in allStationList">
              <el-option :key="index" v-if="item.postStationId==upgradeForm.postStationId" :label="item.stationName"
                         :value="item.id"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item label="流转内容" prop="comment">
          <el-input type="textarea" rows="6" v-model="upgradeForm.comment" placeholder="请输入跟进内容"
                    clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="showUpgrateForm = false">关闭</el-button>
                <el-button type="primary" @click="saveUpgrade">保存</el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";

let vm;
export default {
  data() {
    return {
      type: null,//1流转，2分配 ，3领取
      showUpgrateForm: false,
      sysUserList: [],
      cityList: [],
      postStationList: [],
      allStationList: [],
      upgradeForm: {
        clueId: "",
        comment: "",
        userId: "",
      },
      rules_Upgrade: {
        comment: [
          {
            required: true,
            message: "请输入跟进内容",
            trigger: "change",
          },
        ],
        userId: [
          {
            required: true,
            message: "请选择流转人",
            trigger: "change",
          },
        ],
        cityId: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change",
          },
        ],
        postStationId: [
          {
            required: true,
            message: "请选择驿站",
            trigger: "change",
          },
        ],
        stationId: [
          {
            required: true,
            message: "请选择服务站",
            trigger: "change",
          },
        ],
      },
    };
  },
  beforeCreate() {
    vm = this;
  },
  methods: {
    clueUpgrateForm(type, row, handerId) {
      //type 1流转，2分配 3领取
      this.type = type;

      //流转
      // if (this.skillGroups.length == 0) this.getSkillGroup();
      this.getSysUser();
      this.getAllCity();
      this.getAllPostStation(); //驿站
      this.getAllStationList();

      this.showUpgrateForm = true;
      this.upgradeForm = {
        clueId: row.id,
        comment: "",
        cityId: row.cityId,
        postStationId: row.postStationId,
        stationId: row.stationId,
        operId: globalData.userInfo.id,
        operName: globalData.userInfo.userName,
        // ticketId: row.ticket.id,
        userId: handerId,
      };
    },
    saveUpgrade() {
      console.info(this.upgradeForm);
      this.$refs["upgradeForm"].validate((valid) => {
        if (valid) {
          workercrmapi
            .$axiosGetClueAllocation(this.upgradeForm)
            .then((res) => {
              this.$message.success("操作成功");
              this.showUpgrateForm = false;
              this.$parent.querySearch();
            });
        }
      });
    },
    getSysUser() {
      //城市下拉框
      service.$axiosSysUsergetallUser().then((res) => {
        if (res.data.errno == 0) {
          this.sysUserList = res.data.data;
        }
      });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity().then((res) => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },

    getAllPostStation() {
      workercrmapi.$axiosPostStationgetAllList().then((res) => {
        if (res.data.errno == 0) {
          this.postStationList = res.data.data;
        }
      });
    },

    getAllStationList() {
      //服务站
      wmsApi.$axiosGetAllStationList().then((res) => {
        if (res.data.errno == 0) {
          this.allStationList = res.data.data;
        }
      });
    },
  },
};
</script>
<style>
</style>
